import React from 'react';

import scss from './HighPerformingAudiencesFilters.module.scss';
import { useTranslation } from 'react-i18next';
import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import CommonDropdown from '../../../../../../components/common-dropdown/CommonDropdown';
import useResonanceMessagesLinkSort from '../../../../../../hooks/useResonanceMessagesLinkSort';
import GlobalPercentageSwitch from '../../../../global-percentage-switch/GlobalPercentageSwitch';

function HighPerformingAudiencesFilters({ isGlobalPercentage, sortBy, onChangeGlobalPercentage, onChangeSortBy }) {
  const { t } = useTranslation('resonance');

  const linksSortOptions = useResonanceMessagesLinkSort();

  const handleChangeSort = (newValue) => {
    onChangeSortBy(newValue);
  };

  return (
    <div className={scss.filtersWrapper}>
      <WithLabel label={`${t('value')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={200}>
        <CommonDropdown
          options={linksSortOptions}
          value={sortBy}
          onSelect={handleChangeSort}
          name='top-messages-audiences-sort'
        />
      </WithLabel>

      <GlobalPercentageSwitch
        isGlobalPercentage={isGlobalPercentage}
        onChangeGlobalPercentage={onChangeGlobalPercentage}
      />
    </div>
  );
}

export default HighPerformingAudiencesFilters;
